import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  Spinner,
} from "@fluentui/react-components";

import { useNotify } from "./SuperToast";
import { useTranslation } from "react-i18next";

function DeleteDialog({ isOpen, setIsOpen, useMutationHook, id, name, queryKey }) {
  const { t } = useTranslation();
  const { notify } = useNotify();

  const { mutate, error, isPending } = useMutationHook(
    queryKey,
    () => {
      notify(t("item.messages.deleted", { name: name }), "success");
      setIsOpen(false);
    },
    null
  );

  const handleConfirmation = () => {
    if (!id) throw new Error(`No valid ID for ${name}`);
    console.log(`Deleting ${name} with id ${id}`);
    mutate(id);
  };

  //if (!selectedItem) return null;

  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {t("generic.delete")} {name}
          </DialogTitle>
          <DialogContent>
            {t(`item.questions.delete`, {
              name: name,
            })}
            {error && <div style={{ color: "red" }}>{error.message}</div>}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <Button appearance="primary" disabled={isPending} onClick={handleConfirmation}>
            {isPending ? <Spinner size="tiny" /> : t("generic.confirm")}
          </Button>
          <Button appearance="secondary" disabled={isPending} onClick={() => setIsOpen(false)}>
            {t("generic.cancel")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default DeleteDialog;
